import React from "react";
import "../App.css";

export default function SnippeSection(props) {
  let myAlign = " ";
  let myAlignnment = " ";
  if (props.locate === "right") {
    myAlign = "text-right";
    myAlignnment = "flex-row-reverse";
  }

  return (
    <>
      <div
        className={` snippet-sec lg:flex-row flex-col flex ${myAlignnment} py-8 m-auto w-3/5 justify-between border-b border-b-slate-900`}
      >
        <div className="leftPart lg:w-1/3">
          <h1
            className={`overflow-hidden ${myAlign} text-3xl my-4 font-semibold`}
          >
            {props.title}
          </h1>
          <p className={myAlign}>
            Code snippets are templates that make it easier to enter repeating
            code patterns, such as loops or conditional-statements. In Visual
            Studio Code
          </p>
        </div>
        <div className="flex items-center justify-center text-white text-2xl font-mono font-light rightPart lg:w-1/2 rounded-xl my-color my-5 py-5">
          <pre style={{ fontFamily: "cascadia code" }}>
            {props.code}
            <span id="blink">|</span>
          </pre>
        </div>
      </div>
    </>
  );
}
